import { RiskLevel } from "@portal/types/robot/IRobotEnums";

const carefulPessimisticAmount = -3.2;
const carefulExpectedAmount = 3.8;
const carefulOptimisticAmount = 10.8;

const balancedPessimisticAmount = -5.2;
const balancedExpectedAmount = 4.63;
const balancedOptimisticAmount = 14.5;

const offensivePessimisticAmount = -8.0;
const offensiveExpectedAmount = 5.45;
const offensiveOptimisticAmount = 18.9;

const extraOffensivePessimisticAmount = -10.0;
const extraOffensiveExpectedAmount = 6.0;
const extraOffensiveOptimisticAmount = 22.0;

const getGraphMin = () => {
  return Math.min(
    carefulPessimisticAmount,
    balancedPessimisticAmount,
    offensivePessimisticAmount,
    extraOffensivePessimisticAmount,
  );
};

const getGraphMax = () => {
  return Math.max(carefulOptimisticAmount, balancedOptimisticAmount, offensiveOptimisticAmount, extraOffensiveOptimisticAmount);
};

export const optimisticYield = (riskLevel: RiskLevel): number => {
  switch (riskLevel.toString()) {
    case RiskLevel[RiskLevel.Careful]:
      return carefulOptimisticAmount;
    case RiskLevel[RiskLevel.Balanced]:
      return balancedOptimisticAmount;
    case RiskLevel[RiskLevel.Offensive]:
      return offensiveOptimisticAmount;
    case RiskLevel[RiskLevel.ExtraOffensive]:
      return extraOffensiveOptimisticAmount;
    default:
      return 0;
  }
};

export const expectedYield = (riskLevel: RiskLevel): number => {
  switch (riskLevel.toString()) {
    case RiskLevel[RiskLevel.Careful]:
      return carefulExpectedAmount;
    case RiskLevel[RiskLevel.Balanced]:
      return balancedExpectedAmount;
    case RiskLevel[RiskLevel.Offensive]:
      return offensiveExpectedAmount;
    case RiskLevel[RiskLevel.ExtraOffensive]:
      return extraOffensiveExpectedAmount;
    default:
      return 0;
  }
};

export const pessimisticYield = (riskLevel: RiskLevel): number => {
  switch (riskLevel.toString()) {
    case RiskLevel[RiskLevel.Careful]:
      return carefulPessimisticAmount;
    case RiskLevel[RiskLevel.Balanced]:
      return balancedPessimisticAmount;
    case RiskLevel[RiskLevel.Offensive]:
      return offensivePessimisticAmount;
    case RiskLevel[RiskLevel.ExtraOffensive]:
      return extraOffensivePessimisticAmount;
    default:
      return 0;
  }
};

export const AgreementDetailsData = (riskLevel: RiskLevel) => {
  return {
    title: null,
    chart: {
      type: "column",
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    yAxis: {
      min: getGraphMin(),
      max: getGraphMax(),
      title: null,
      gridLineWidth: 0,
      labels: {
        enabled: false,
      },
      visible: true,
      plotLines: [
        {
          color: "#606060",
          width: 1,
          value: 0,
        },
      ],
    },
    xAxis: {
      type: "category",
      gridLineWidth: 0,
      lineColor: "transparent",
      tickColor: "transparent",
    },
    plotOptions: {
      column: {
        threshold: 0,
      },
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: "{point.y:.1f}%",
        },
      },
    },
    series: [
      {
        colorByPoint: true,
        data: [
          { name: "Dårlig", y: pessimisticYield(riskLevel), color: "#ff6a00" },
          { name: "Forventet", y: expectedYield(riskLevel), color: "#5900ff" },
          { name: "Bra", y: optimisticYield(riskLevel), color: "#5900ff" },
        ],
      },
    ],
  };
};
